import {Injectable, Inject} from '@angular/core';
import {Observable, Subject} from 'rxjs/Rx';

import 'firebase/database';
import { AngularFireDatabase } from 'angularfire2/database';



@Injectable()
export class GradoService {
  sdkDb: any;

  constructor(private db: AngularFireDatabase) {

  }

  findGrado(key: string): Observable<any> {

    return this.db.list( '/grado' + key).valueChanges();
  }

  getAll(): Observable<any> {

    return this.db.list( '/todos').valueChanges();
  }

}
